import { useState, useEffect } from 'react';
import { galleryAPI } from '@/lib/api';

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await galleryAPI.getAll();
        setImages(response.data);
      } catch (error) {
        console.error('Failed to fetch gallery:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  if (loading || images.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-light text-white mb-4">
            گالری <span className="text-[#D4AF37]">سمینارها</span>
          </h2>
          <p className="text-lg text-zinc-400">
            لحظات به‌یادماندنی از سمینارها و رویدادهای ما
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((image) => {
            // Handle relative URLs by prepending backend URL
            const imageUrl = image.image_url?.startsWith('http') 
              ? image.image_url 
              : `${process.env.REACT_APP_BACKEND_URL}${image.image_url}`;
            
            return (
              <div
                key={image.id}
                className="group relative overflow-hidden rounded-xl aspect-square cursor-pointer"
              >
                <img
                  src={imageUrl}
                  alt={image.title_fa || 'Gallery image'}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <div>
                    <h3 className="text-white font-medium text-sm">{image.title_fa}</h3>
                    {image.description_fa && (
                      <p className="text-zinc-300 text-xs mt-1">{image.description_fa}</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
